export default {
  alignItems: "center",
};
